<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Terence McAdams’ books seek to educate with plot-twisting narratives interweaving science, technology and history. His writing focuses on positive role modelling through richly-drawn characters. His doctoral research focused on girls’ computer programming, and he advocates for girls in STEM. Terence also writes technical examination papers for the International Baccalaureate and publishes many articles on technology, data analysis and education. Terence seeks to enlighten and engage readers about scientific advancements through intrigue.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b2c197ca